import { useState } from "react";
import { useQuery } from "react-query";
import { TabPanel, TabView } from "primereact/tabview";
import { Link, useLocation, useParams } from "react-router-dom";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../../components/panel/panel";
import ClickSignSigners from "./ClickSignSigners";
import ClickSignIntegration from "./ClickSignIntegration";
//services
import { getUsers } from "../../../../services/GeneralRegistration/getUsers";
import { getConfigSign } from "../../../../services/Enterprise/ClickSign/getConfigSign";
import { getConfigEnterprise } from "../../../../services/Enterprise/ClickSign/getConfigEnterprise";
import { postConfigEnterprise } from "../../../../services/Enterprise/ClickSign/postConfigEnterprise";
import { deleteSignersEnterprise } from "../../../../services/Enterprise/ClickSign/deleteSignersEnterprise";
import usePermission from "../../../../hooks/usePermission";
import { useAppContext } from "../../../../context/AppContext";

const ClickSignConfig = () => {
  const { id } = useParams(); //get id
  const { state } = useLocation();
  const { permissions } = useAppContext();
  usePermission("90"); // Configurar Integração ClickSign

  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/clickSignConfig/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações da ClickSign
        </Link>
      ),
    },
  ];

  const {
    data: signers,
    refetch: refetchSigners,
    isLoading: isLoadingSigners,
  } = useQuery({
    queryKey: [`signers${id}`],
    queryFn: () => getUsers(),
    enabled: !!permissions?.includes("90")
  });

  const {
    data: config_sign,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [`config_sign${id}`],
    queryFn: () => getConfigSign(id),
    enabled: !!permissions?.includes("90")
  });
  const {
    data: registeredSigners,
    refetch: refetchRegisterSigners,
    isLoading: isLoadingRegisterSigners,
  } = useQuery({
    queryKey: [`registeredSigners${id}`],
    queryFn: () => getConfigEnterprise(id),
    enabled: !!permissions?.includes("90")
  });
  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      <Panel title="Configurar Integração ClickSign">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="meu-tabview pt-3"
        >
          <TabPanel header="Integração" leftIcon="fa-solid fa-paper-plane mx-2">
            <ClickSignIntegration id={id} />
          </TabPanel>
          <TabPanel header="Signatários" leftIcon="fa-solid fa-users-gear mx-2">
            <ClickSignSigners
              id={id}
              registeredSigners={registeredSigners}
              signers={signers}
              refetchSigners={refetchSigners}
              isLoadingSigners={isLoadingSigners}
              refetchRegisterSigners={refetchRegisterSigners}
              isLoadingRegisterSigners={isLoadingRegisterSigners}
              config_sign={config_sign}
              refetch={refetch}
              isLoading={isLoading}
              sendPost={postConfigEnterprise}
              configEnterprise={true}
              deleteSigners={deleteSignersEnterprise}
            />
          </TabPanel>
        </TabView>
      </Panel>
    </>
  );
};

export default ClickSignConfig;
